import { render, staticRenderFns } from "./ReviewSlider.vue?vue&type=template&id=2db4ba11&scoped=true&"
import script from "./ReviewSlider.vue?vue&type=script&setup=true&lang=js&"
export * from "./ReviewSlider.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ReviewSlider.vue?vue&type=style&index=0&id=2db4ba11&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db4ba11",
  null
  
)

export default component.exports